export default "/images/vendor/flag-icon-css/flags/4x3/cm.svg?7578267e8568b1490427bb8db78871b6";